module.exports = __webpack_public_path__ + "static/media/32-10.ad6ab7ba.mp3";